import { motion } from 'framer-motion';

const RecykalLogoLoader = (props) => {
  const {
    size = 'sm',
    className = '',
    margin = 'my-3',
    style,
    colors = {
      bottomLeft: 'black',
      bottomRight: 'black',
      topRight: 'black',
      topLeft: 'black',
    },
    animate = false,
    animateType = 'groupTogether',
    animateDuration = 1.5,
  } = props;
  const area =
    size === 'md'
      ? { width: '50', height: '50' }
      : size === 'lg'
        ? { width: '70', height: '70' }
        : size === 'xs'
          ? { width: '25', height: '20' }
          : { width: '48', height: '35' };

  return (
    <div
      className={`logo_loader d-flex align-items-center justify-content-center w-100 ${className} ${margin}`}
      style={style}>
      <motion.svg
        width={area?.width}
        height={area?.height}
        viewBox="0 0 108 97"
        initial={{ scale: 1, opacity: 0.8 }}
        animate={
          animate
            ? {}
            : {
                rotate: [0, 360],
                scale: [1, 1.2, 1],
                opacity: [0.8, 0.7, 0.8],
              }
        }
        transition={
          animate
            ? {}
            : {
                duration: 2,
                repeat: Infinity,
                repeatType: 'loop',
                ease: 'easeInOut',
              }
        }
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <motion.path
          initial={animate && { scaleY: -1, translateX: -5, rotate: 180 }}
          animate={animate && { scaleY: 1, translateX: 0, rotate: 0 }}
          transition={
            animate && {
              delay: 0,
              duration: animateDuration,
              repeat: Infinity,
              repeatType: 'loop',
              ease: 'easeInOut',
            }
          }
          d="M29.21 50.8001C24.96 42.1701 20.37 33.3801 19.67 23.7001C19.58 22.1801 19.58 20.6601 19.67 19.1501C19.67 18.3401 19.79 17.5301 19.9 16.6501C19.96 16.1601 19.9 14.7201 20.26 14.3501C10.33 25.1501 0 39.7501 0 48.0501C0 60.1501 22.46 86.2401 32.94 93.2201C43.42 100.2 58.55 93.4401 46.44 79.9301C45.07 78.4101 29.95 60.7901 29.21 50.8101"
          fill={colors?.bottomLeft || 'black'}
        />
        <motion.path
          initial={animate && { scaleY: -1, translateX: -5, rotate: 180 }}
          animate={animate && { scaleY: 1, translateX: 0, rotate: 0 }}
          transition={
            animate && {
              delay: 0,
              duration: animateDuration,
              repeat: Infinity,
              repeatType: 'loop',
              ease: 'easeInOut',
            }
          }
          d="M32.94 2.79C29.4 5.32 26.11 8.19 23.12 11.35C21.68 16.83 21.64 22.59 23.01 28.09C24.52 34.14 26.61 40.03 29.25 45.68C29.95 36.17 44.72 17.98 46.44 16.06C55.24 6.25 49.66 0 41.93 0C39.02 0 35.81 0.88 32.94 2.79Z"
          fill={colors?.topLeft || 'black'}
        />
        <motion.path
          initial={animate && { scaleY: -1, translateX: -5, rotate: 180 }}
          animate={animate && { scaleY: 1, translateX: 0, rotate: 0 }}
          transition={
            animate && {
              delay: 0,
              duration: animateDuration,
              repeat: Infinity,
              repeatType: 'loop',
              ease: 'easeInOut',
            }
          }
          d="M60.88 79.9301C48.77 93.4401 63.89 100.21 74.38 93.2201C77.92 90.6801 81.21 87.8101 84.2 84.6501C85.64 79.1601 85.68 73.4101 84.31 67.9001C82.8 61.8501 80.71 55.9601 78.07 50.3101C77.35 59.8901 62.6 78.0201 60.88 79.9301Z"
          fill={colors?.bottomRight || 'black'}
        />
        <motion.path
          initial={animate && { scaleY: -1, translateX: -5, rotate: 180 }}
          animate={animate && { scaleY: 1, translateX: 0, rotate: 0 }}
          transition={
            animate && {
              delay: 0,
              duration: animateDuration,
              repeat: Infinity,
              repeatType: 'loop',
              ease: 'easeInOut',
            }
          }
          d="M78.12 45.1899C82.35 53.8399 86.96 62.6099 87.66 72.3599C87.75 73.8699 87.75 75.3899 87.66 76.8999C87.66 77.7199 87.54 78.5399 87.43 79.3999C87.43 79.8899 87.43 81.3499 87.07 81.7099C96.99 70.8599 107.29 56.2399 107.29 47.9499C107.29 35.8499 84.83 9.75995 74.35 2.79995C63.87 -4.16005 48.76 2.56995 60.88 16.0799C62.25 17.6099 77.35 35.2299 78.11 45.1999"
          fill={colors?.topRight || 'black'}
        />
      </motion.svg>
    </div>
  );
};

export default RecykalLogoLoader;
